import Promise from 'bluebird';
import AnchorAPIError from './AnchorAPIError';

const optOutOfPodcastDistribution = ({ webStationId } = {}) => {
  if (!webStationId) {
    throw new Error('No station provided');
  }
  return new Promise((resolve, reject) => {
    fetch(
      `/api/proxy/v3/stations/webStationId:${webStationId}/distribution/optout`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    )
      .then(resolve)
      .catch(reject);
  }).then(response => {
    if (!response.ok) {
      throw new AnchorAPIError(
        response,
        `Non 200 response status: ${response.status}`
      );
    }
  });
};

export { optOutOfPodcastDistribution };
